import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../../packages/kiti/components/presentation/Text'
import AverageFormRepliesAmountByPeriodLoader from './_load/AverageFormRepliesAmountByPeriodLoader'
import Chart from './Chart'
import PeriodDescription from '../../_shared/PeriodDescription'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import WidgetWrapper from '../../WidgetWrapper'

const Widget = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <Grid justify="space-between" gap={1}>
        <Col>
          <Title size="h5" noMargin>
            {widget.name}
          </Title>
          <PeriodDescription />
        </Col>
        <Col flex={1} />
      </Grid>

      <Separator weight={4} />
      <AverageFormRepliesAmountByPeriodLoader>
        <Chart widget={widget} />
      </AverageFormRepliesAmountByPeriodLoader>
    </WidgetWrapper>
  )
}

export default Widget
